import FaqContainer from "../../components/miscellaneous/faq";

const Faq = () => {
  return <FaqContainer />;
};

export default Faq;
